var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 48,
    viewBox: "0 0 90 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.6341 7.20654L7.40811 5.54924L1 26.044L1.38671 28.6403L17.0201 28.6956L18.3459 30.5738L20.4451 29.3585L36.9071 29.248L43.3151 30.2976L53.0929 29.3032L53.0377 33.5016L54.3082 33.3359L54.9711 37.7552L59.6114 41.8431L60.661 46.7596L63.5336 46.2624L65.0804 42.3403L67.0138 42.1193L68.3949 40.3516L71.5436 39.1362V45.8757L81.6529 42.1193L88.1161 41.7326L89 40.6278L87.7847 39.2467L88.9448 36.3189L88.5028 33.1701L87.3428 30.2423L83.5863 27.5907L85.575 30.2423L85.796 32.7282L87.4532 33.4464L86.7903 37.6447L83.0339 38.5286L81.4319 39.9096L74.3057 37.1475L74.7477 34.054L69.6102 30.2976L71.5989 29.248L69.7207 23.5029L67.5662 21.4589L63.865 21.1275L62.484 20.4093L61.9316 17.6472L66.6824 13.7803L66.9586 11.7364L70.4388 10.9078L72.5932 9.30575L71.9856 7.42753L68.8368 8.36664L67.29 1.24039L62.5392 1.51662L61.2134 3.17387L58.8933 2.62147L58.4514 4.77591L55.6341 7.20654Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMa);
export default __webpack_public_path__ + "static/media/MA.c918ff5a819cf81337b2eab03b816972.svg";
export { ForwardRef as ReactComponent };